import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getFaqs,
  deleteFaq,
  getNextFaqs,
  getPreviousFaqs,
} from "../../store/actions/faqs_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/faqs_enum";
import DataTable from "../../components/common/DataTable";
const AllFaqs = ({
  getFaqs,
  deleteFaq,
  getNextFaqs,
  getPreviousFaqs,
  faq: { loading, faqs },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteFaq(deleteEntry);
      }
      getFaqs({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (faqs && faqs.length === LIMIT) {
      const lastFaq = faqs[faqs.length - 1];
      getNextFaqs({ last: lastFaq });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastFaq = faqs[0];
      getPreviousFaqs({
        first: lastFaq,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getFaqs({ term: term, termField: termField });
    }
  };
  const deleteFaqClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getFaqs({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Faqs"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Faq"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="faqs" title="Faq" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={faqs}
                      field={"faqs"}
                      page={page}
                      deleteBtnClicked={deleteFaqClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={faqs}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ faq: state.faq });

const mapDispatchToProps = {
  getFaqs,
  deleteFaq,
  getNextFaqs,
  getPreviousFaqs,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllFaqs);
